import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React, { memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { monthsOptions } from './values'
import { useForm } from 'hooks/useForm'

export const FormOneSeasonRuleEdit = memo((props) => {
  const { setSeasons, seasons, season, months } = props
  const { deleteMode } = useSelector(state => state.contractsCatalog)
  const [ monthsOptionsFiltered, setMonthsOptionsFiltered ] = useState(monthsOptions)
  const { inputValues, handleInputOnChange } = useForm({ firstMonth: monthsOptions[season.firstMonth].value, secondMonth: monthsOptions[season.secondMonth].value })
  const { firstMonth, secondMonth } = inputValues

  useEffect(() => {
    if(firstMonth !== season.firstMonth || secondMonth !== season.secondMonth)
      setSeasons(seasons.map(item => {
        if (item.id === season.id) return {...item, firstMonth: firstMonth, secondMonth: secondMonth}
        else return item
    } ))
  }, [firstMonth, secondMonth])

  useEffect(() => {
    let newMonths = monthsOptions.filter(month => !months.includes(month.value))
    if (months.includes(monthsOptions[firstMonth].value)) newMonths = [...newMonths, monthsOptions[firstMonth]]
    if (months.includes(monthsOptions[secondMonth].value)) newMonths = [...newMonths, monthsOptions[secondMonth]]
    setMonthsOptionsFiltered(newMonths.sort((a,b) => {
      if(a.value < b.value) return -1
      else if(a.value > b.value) return 1
      return 0
    }))
  }, [months])

  return (
    <>
      <FormControl style={{width: '50%'}} variant="outlined">
        <InputLabel>Primer mes:</InputLabel>
        <Select
          name="firstMonth"
          value={firstMonth}
          onChange={e => handleInputOnChange(e)}
          label="Primer mes:"
          disabled={deleteMode}
        > 
          { monthsOptionsFiltered.map(item => <MenuItem key={item.value} value={item.value}>{item.month}</MenuItem>) }
        </Select>
      </FormControl>
      <FormControl style={{width: '50%'}} variant="outlined">
        <InputLabel>Segundo mes:</InputLabel>
        <Select
          name="secondMonth"
          value={secondMonth}
          onChange={e => handleInputOnChange(e)}
          label="Segundo mes:"
          disabled={deleteMode}
        > 
          { monthsOptionsFiltered.map(item => <MenuItem key={item.value} value={item.value}>{item.month}</MenuItem>) }
        </Select>
      </FormControl>
    </>
  )
})
